/* eslint-disable import/no-default-export */
import classNames from 'classnames';
import React from 'react';

import { forTemplate } from 'app/common/lib/util/i18n';
const format = forTemplate('directory_power_up_item');

import { BadgeProps } from './types';
import { Icon, IconName } from 'app/common/components/controls';

import styles from './power-up.less';

const Badges: React.FunctionComponent<BadgeProps> = ({
  button,
  usage,
  promotional,
  staffPick,
}) => (
  <div className={styles.badges}>
    {button}
    {typeof usage === 'number' && usage > 0 && (
      <div
        className={styles.pupBadge}
        title={format('usage-explanation', { count: usage.toLocaleString() })}
      >
        <Icon className={styles.usageBadgeIcon} name={IconName.Board} />
        <span>{usage.toLocaleString()} +</span>
      </div>
    )}
    {promotional && (
      <div
        className={classNames(styles.pupBadge, styles.bonusBadge)}
        title={format('bonus-explanation')}
      >
        <span>{format('bonus')}</span>
      </div>
    )}
    {staffPick && (
      <div
        className={classNames(styles.pupBadge, styles.bonusBadge)}
        title={format('staff-pick-explanation')}
      >
        <span>{format('staff-pick')}</span>
      </div>
    )}
  </div>
);

export default Badges;
